module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8gA9A"))).then(() => parcelRequire('d0iPb'));